<ba-bub-dropdown
  id="typwahl"
  (onSelectionChanged)="onChange($event)"
  [selectedValue]="getCurrentSelection().label"
  [possibleValues]="typeLabels"
  [label]="messages.SUCHTYPAUSWAHL_LABEL"
  [title]="messages.SUCHTYP_TITLE"
></ba-bub-dropdown>
